const urlObjc = {
  loginUrl: '登录接口',
  homeDataUrl: '/house/getAllHouses',//用户下的家庭列表
  airElectricityUrl: '/energyConsumption/getAirSystemElectricityEnergy/',//空调电量
  freshAirElectricityUrl: '/energyConsumption/getFreshAirSystemElectricityEnergy/',//新风电量
  hotWaterUrl: '/energyConsumption/getHotWaterSystemElectricityEnergy/',//热水电量
  lampElectricityUrl: '/energyConsumption/getLampSystemElectricityEnergy/',//灯控电量
  socketElectricityUrl: '/energyConsumption/getSocketSystemElectricityEnergy/',//插座电量
  purificationWaterElectricityUrl: '/energyConsumption/getWaterPurificationSystemElectricityEnergy/',//净水电量
  envHistoryDataUrl: '/energyConsumption/getGatewayEnvHistoryData/',//环境历史数据
  systemEnergysUrl: '/energyConsumption/getSystemsEnergys/',//各系统下的能耗
  smartSystemEnergysUrl: '/energyConsumption/getSystemEneryDatas/',//智能模块下各系统下能耗对比
  settingGatewayIsShow: '/house/updateGatewayIsShow/',//设置指定网关是否可展示
  smartHeatingSystemUrl: '/energyConsumption/getHeatingSystemReport/',//获取智能采暖系统能耗数据
  smartHeatingGasWithDayUrl: '/energyConsumption/getBoilerGasQuantityRangDataById/',//获取采暖气量
}
export default urlObjc


// WEBPACK FOOTER //
// ./src/urls/urls.js